import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import { COLORS } from 'shared/constants/COLORS';
const { PRIMARY_ICON } = COLORS;

const PlayButtonIcon = (props: SvgIconProps) => {
  return (
    <>
      <SvgIcon width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g fill="none" fillRule="evenodd">
          <circle fill="#FFF" cx="13" cy="13" r="8.328" />
          <path
            d="M13 0C5.82 0 0 5.82 0 13s5.82 13 13 13 13-5.82 13-13S20.18 0 13 0zM9.448 18.654V7.346L19.241 13l-9.793 5.654z"
            fill={props.htmlColor || PRIMARY_ICON}
            fillRule="nonzero"
          />
        </g>
      </SvgIcon>
    </>
  );
};

export default PlayButtonIcon;
